import useCurrency from "@Currency/hooks/useCurrency";
import {ReactNode} from "react";
import useGetPriceForPassengerClass from "@CheckOrder/features/classPicker/hooks/useGetPriceForPassengerClass";
import AvailablePassengerClassType from "@CheckOrder/features/classPicker/types/AvailablePassengerClass.type";

interface PassengerClassProps {
    passengerClass: AvailablePassengerClassType,
    passengerId: number,
    centerPrice?: boolean,
    info?: ReactNode,
    isReturn: boolean,
}

function PassengerClass({passengerClass, passengerId, centerPrice, info, isReturn}: PassengerClassProps) {
    const {val} = useCurrency()
    const {getPrice} = useGetPriceForPassengerClass(passengerClass, passengerId, isReturn)

    return (
        <>
            <div className="passenger-class__title">
                {passengerClass.title}
                {info && (
                    info
                )}
            </div>
            <p className="passenger-class__description">
                {passengerClass.description}
            </p>
            <p className={`passenger-class__price ${centerPrice ? "center" : ""}`}>
                {getPrice()}
                &nbsp;
                {val}
            </p>
        </>
    )
}

export default PassengerClass